<template>
  <!-- Pick one level of impact or probability; clicking the chosen level clears it (US 9370) -->
  <div class="rk-lv" role="radiogroup" :style="{ gridTemplateColumns: 'repeat(' + levels.length + ', minmax(0, 1fr))' }">
    <button v-for="(level, index) in levels"
            :key="level"
            type="button"
            role="radio"
            :aria-checked="value === level ? 'true' : 'false'"
            :class="{ on: value === level }"
            :disabled="disabled"
            :qid="qid ? qid + '-' + (index + 1) : null"
            @click="$emit('input', value === level ? null : level)">
      <b>{{ index + 1 }}</b>{{ $t(kind + '.' + levelKey(level)) }}
    </button>
  </div>
</template>

<script>
  import {levelKey} from '@/components/risk/riskScale.js';

  export default {
    name: 'RiskLevelPicker',
    props: {
      value: { type: String, default: null },
      levels: { type: Array, required: true },
      // impact or probability, for the level names
      kind: { type: String, required: true },
      disabled: { type: Boolean, default: false },
      qid: { type: String, default: '' }
    },
    methods: {
      levelKey: levelKey
    }
  }
</script>
